import { useAtomValue } from 'jotai'
import { FC } from 'react'
import { PermittedLandUsesKey } from 'src/common-services/types/zone-types'
import { ZoningUsesListsContent } from 'src/components/insights/zoning/uses/lists'
import { parcelZoning } from 'src/v2/state/owner-reveal/parcel-zoning'

type ParcelZoningUsesProps = {
  type: PermittedLandUsesKey
  search?: string
}
export const ParcelZoningUsesContent: FC<ParcelZoningUsesProps> = ({ type, search }) => {
  const zoning = useAtomValue(parcelZoning)

  return <ZoningUsesListsContent details={zoning?.zoneDetails} search={search} type={type} />
}
